// src/features/captions/schemas/GenerateTermsForm.schema.ts

import { z } from 'zod';
import {
  CAPTION_GENERATE_CATEGORY_VALUES,
  CAPTION_GENERATE_CONSTRAINTS,
} from '@/lib/constants/captions';

const urlField = z.string().refine(
  (val) => !val || /^https?:\/\/.+/.test(val.trim()),
  'Must be a valid URL starting with http:// or https://',
);

/** AI term-research modal form. Form fields are non-null strings; empties are
 *  dropped at the request boundary (CaptionTermUtils.buildGenerateRequest). */
export const GenerateTermsSchema = z.object({
  orgName: z.string()
    .trim()
    .min(1, 'Organization name is required')
    .max(CAPTION_GENERATE_CONSTRAINTS.ORG_NAME_MAX, `Max ${CAPTION_GENERATE_CONSTRAINTS.ORG_NAME_MAX} characters`),

  category: z.enum(CAPTION_GENERATE_CATEGORY_VALUES),

  /** Free-text category, used only when category === 'other'. */
  categoryOther: z.string()
    .max(CAPTION_GENERATE_CONSTRAINTS.ORG_NAME_MAX, `Max ${CAPTION_GENERATE_CONSTRAINTS.ORG_NAME_MAX} characters`),

  location: z.string()
    .max(CAPTION_GENERATE_CONSTRAINTS.ORG_NAME_MAX, `Max ${CAPTION_GENERATE_CONSTRAINTS.ORG_NAME_MAX} characters`),

  sourceUrls: z.array(urlField)
    .max(CAPTION_GENERATE_CONSTRAINTS.SOURCE_URLS_MAX),

  contextNote: z.string()
    .max(CAPTION_GENERATE_CONSTRAINTS.CONTEXT_NOTE_MAX, `Max ${CAPTION_GENERATE_CONSTRAINTS.CONTEXT_NOTE_MAX} characters`),
});

export type GenerateTermsFormData = z.infer<typeof GenerateTermsSchema>;
